import React, {useState} from "react"
import {Col, Row} from "react-bootstrap"

import {ExportTableButton} from "../../component/Button/ExportTableButton"
import LoadingV2 from "../../component/Loading/LoadingV2"
import {TitlePage} from "../../component/Page/Title"
import Notify from "../../services/Notify"

function IntentoryItemsHeaderCustom({
  endpoint,
}) {
  const [isLoading, setIsLoading] = useState(false)

  const exportToCsv = async () => {
    try {
      setIsLoading(true)
      const url = `${endpoint}&sort=productType.reference,DESC&size=5000&export=true`
      window.open(url);
      // const { content } = await new HttpRequest().get(endpoint)
      // ExportData.exportToCsv(content, inventoryItemsMetadata.columns, 'Itens do inventário')
    } catch (error) {
      Notify.error('Houve um erro ao gerar o csv', error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
      <Row>
        <Col md={8} sm={8} lg={8}>
          <TitlePage title="Itens do inventário"/>
        </Col>
        <Col md={4} className="d-flex justify-content-end">
          <LoadingV2 isLoading={isLoading}>
            <ExportTableButton title="Exportar para CSV" icon="file-text-o"
                               onClick={exportToCsv}/>
          </LoadingV2>
        </Col>
      </Row>
  )
}

export default IntentoryItemsHeaderCustom



// WEBPACK FOOTER //
// ./src/Inventory/components/inventoryItemSHeaderCustom.js